import React, { useRef, useEffect } from 'react'
import Icons from '../components/Icons'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { Fade } from 'react-awesome-reveal'

const ServicesSection = ({ onSectionChange, currentSection }) => {
  const servicesSectionRef = useRef()

  const { t } = useTranslation()

  const handleScroll = (event) => {
    const scrollTop = servicesSectionRef.current.getBoundingClientRect().bottom
    if (scrollTop <= 300 && currentSection === 'section3') {
      onSectionChange('section4')
    } else if (scrollTop > 300 && currentSection === 'section4') {
      onSectionChange('section3')
    }
  }

  const nextSection = (event, section) => {
    event.preventDefault()
    document
      .getElementById(section)
      .scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  const services = [
    {
      name: t('servicesSection.sections.first'),
      description: t('servicesSection.services.webdev'),
      icon: 'web-development',
      color: 'text-white bg-royal-blue'
    },
    {
      name: t('servicesSection.sections.second'),
      description:
      t('servicesSection.services.sysadmin'),
      icon: 'app-development',
      color: 'text-martinique-500 bg-energy-yellow'
    },
    {
      name: t('servicesSection.sections.third'),
      description:
      t('servicesSection.services.pm'),
      icon: 'diamond',
      color: 'text-white bg-radical-red'
    }
  ]

  return (
    <section
      ref={servicesSectionRef}
      id="section3"
      className="relative bg-gray-100 w-full"
    >
      <div className="w-5/6 md:w-3/4 lg:w-4/6 mx-auto py-16">
      <Fade direction="up">
        <h2 className="title font-bold text-4xl text-martinique relative z-10">
          Services
        </h2>
      </Fade>

        <div className="flex flex-col md:flex-row pt-12 md:pt-24 justify-between items-start content-center">
          {services.map((value, index) => {
            return (
              <div
                key={index}
                className={`md:mr-10 ${index > 0 ? 'mt-8' : ''} md:mt-0 rounded-3xl text-center duration-300 transform transition hover:-translate-y-3 p-8 ${value.color}`}
              >
                <Icons name={value.icon} className="mx-auto w-20 h-20" />
                <h3 className="font-medium text-xl mt-5">{value.name}</h3>
                <p
                  className="mt-4 font-light"
                  dangerouslySetInnerHTML={{ __html: value.description }}
                ></p>
              </div>
            )
          })}
        </div>
      </div>
      <p className="text-martinique-400 text-center">{t('servicesSection.cta')[0]} <a href="#" onClick={(e) => nextSection(e, 'section7')} className="text-radical-red-500">{t('servicesSection.cta')[1]}</a> {t('servicesSection.cta')[2]} 👋</p>
    </section>
  )
}

export default ServicesSection
